import Alpine from "../alpine.js"
import { createConsumer } from "@rails/actioncable"
import { client } from "../client.js"

Alpine.data("messageContainer", ({ messages, to, userId }) => ({
  subscription: null,
  initialized: false,
  uploadingPhoto: false,
  newMessageBody: "",
  photoId: null,
  photoUrl: null,
  messages,
  userId,
  to,
  init () {
    this.$nextTick(() => {
      this.$refs.messageContainer.style.height = `${this.$refs.messageContainer.clientHeight}px`
      this.initialized = true
      setTimeout(() => {
        this.$refs.messageContainer.scroll({
          top: this.$refs.messageContainer.scrollHeight,
          behavior: 'smooth'
        })
      }, 120)
    })

    this.createSocketConnection()
  },
  createSocketConnection () {
    const consumer = createConsumer()
    this.subscription = consumer.subscriptions.create({ channel: 'MessageChannel', to_id: to }, {
      received: (message) => {
        this.messages.push(message)
        this.acknowledgeMessage(message)

        this.$nextTick(() => {
          this.$refs.thinking.classList.add("hidden")
          this.$refs.messageContainer.scrollTo({
            top: this.$refs.messageContainer.scrollHeight,
            behavior: 'smooth'
          })
        })
      }
    })
  },
  submitForm () {
    let formData = new FormData(this.$refs.newMessageForm);
    let messageBody = formData.get('message[body]');
    let photoId = formData.get('message[photo_id]');

    if (!messageBody.trim() && this.photoId === null) {
      return;
    }

    fetch(this.$refs.newMessageForm.action, {
      method: "POST",
      body: formData,
    }).then((response) => {
      this.addMessage(this.newMessageBody, this.photoUrl)
      this.newMessageBody = ""
      this.photoId = null
      this.photoUrl = null
      if (this.$refs.mode.value === "ask_doobee") {
        setTimeout(() => {
          this.$refs.thinking.classList.remove("hidden")
          this.$nextTick(() => {
            this.$refs.messageContainer.scrollTo({
              top: this.$refs.messageContainer.scrollHeight,
              behavior: 'smooth'
            })
          })
        }, 2000)
      }
    })

    this.$nextTick(() => {
      this.$refs.messageBodyField.focus()
    })
  },
  fileInputChange (event) {
    this.uploadingPhoto = true
    let file = event.target.files[0]

    return client.get("/photos/new/")
      .then((response) => {
        // Form Data entries need to be ordered or aws complains so the
        // key needs to come before the file attribute
        let formData = new FormData()
        Object.keys(response).forEach((key, index) => {
          formData.append(key, response[key])
        })
        formData.append("file", file)

        return fetch(this.$refs.fileInput.dataset.uploadUrl, {
          headers: { "Accept": "application/json" },
          method: "POST",
          body: formData
        })
      })
      .then((storageReponse) => { return storageReponse.text() })
      .then((xml) => {
        let parser = new DOMParser()
        xmlDoc = parser.parseFromString(xml, "application/xml")
        let key = xmlDoc.querySelector('Key').innerHTML
        return key
      })
      .then((key) => {
        return client.post("/photos", { picture_key: key })
      })
      .then((response) => {
        this.uploadingPhoto = false
        this.photoId = response.id
        this.photoUrl = response.url
        this.$nextTick(() => { this.submitForm() })
      })
      .catch((error) => {
        console.log({ error })
        this.uploadingPhoto = false;
        this.$dispatch('add-message', { type: 'error', title: 'Unable to upload image, please try again.' })
      })
  },
  addMessage(body = null, photo_url = null) {
    this.messages.push({
      id: Math.floor((new Date()).getTime()),
      time: (new Date().toJSON()),
      to_user_id: this.to,
      from_user_id: this.userId,
      body: body || null,
      photo_url: photo_url || null
    });

    this.$nextTick(() => {
      this.$refs.messageContainer.scrollTo({
        top: this.$refs.messageContainer.scrollHeight,
        behavior: 'smooth'
      });
    });
  },
  formatDate (time) {
    let date = new Date(time)
    let options = { month: 'short' }
    let day = date.getDate()
    let month = date.toLocaleString('en-US', options)
    let hours = date.getHours()
    let period = hours >= 12 ? 'PM' : 'AM'

    hours = hours % 12 || 12 // Convert to 12-hour format; '0' becomes '12'
    let minutes = date.getMinutes().toString().padStart(2, '0') // Pad minutes with leading zero

    return `${day} ${month} ${hours}:${minutes} ${period}`;
  },
  acknowledgeMessage (message) {
    client.post("/message_acknowledgements", { message_id: message.id })
  },
  destroy () {
    if (this.subscription) {
      this.subscription.unsubscribe()
    }
  }
}))
